module.exports = __webpack_public_path__ + "static/media/alien.6e119dd7.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/alien.PNG
// module id = 836
// module chunks = 53